import React, {useState, Fragment, useEffect, useContext} from 'react';
import {Grid, Typography, Divider, Checkbox, Snackbar} from '@material-ui/core';
import Loading from "../../../../../Loading";
import {FieldArray, useFormikContext} from "formik";
import {makeStyles} from "@material-ui/core/styles";
import Alert from '@material-ui/lab/Alert';
import PopOverDetails from "../../../../../PopOverInfo";
import CotizarContext from "../../../../../../context/CotizarContext";
import NumberField from "../../../../FormikUtils/NumberField";
import { IconScooter, IconCamera, IconDeviceLaptop, IconDeviceTablet, IconBike } from '@tabler/icons';
import {numerosCoberturasOpcionales} from "../../../../../utils/checkOptionalCoveragesSelected";


const useStyles = makeStyles((theme) => ({
    errorMessage: {
        color: "red",
        fontSize: "12px",
        textAlign: "center",
        marginTop: "4px"
    },
    title: {
        fontSize: "18px",
        color: "#bb0d66",
        fontFamily: "EncodeSansBold"
    },
    coberturasTable: {
        padding: theme.spacing(1),
    },
    tableHeader: {
        fontFamily: 'EncodeSansRegular',
        fontSize: "18px",
        lineHeight: "1"
    },
    tableRowLabel: {
        fontFamily: 'Nunito'
    },
    centerContent: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },
    alert: {
        backgroundColor: theme.palette.warning.dark
    },
    coverageIcon: {
        width: "40px",
        height: "40px",
        strokeWidth: "2px",
    }
}));

export default function CoberturasForm(props) {
    const {
        formField: {
            coberturas: {
                sumaAsegurada,
            },
            coberturasAdicionales: {
                sumaAseguradaAdicional,
            },
        },
        cotizacionRetomada,
    } = props;

    const {coberturasInfo} = useContext(CotizarContext);
    const classes = useStyles();
    const {values, setFieldValue} = useFormikContext();
    const [dictCoberturas, setDictCoberturas] = useState(null);
    const [openAlert, setOpenAlert] = useState(false);
    const [alertMessage, setAlertMessage] = useState(null);
    const [coberturasAdicionalesDict, setCoberturasAdicionalesDict] = useState([
        {selectedCoberturaAdicional: false, numeroCobertura: "26", sumaAsegurada: 0},
        {selectedCoberturaAdicional: false, numeroCobertura: "36", sumaAsegurada: 0},
        {selectedCoberturaAdicional: false, numeroCobertura: "37", sumaAsegurada: 0},
        {selectedCoberturaAdicional: false, numeroCobertura: "48", sumaAsegurada: 0},
        {selectedCoberturaAdicional: false, numeroCobertura: "49", sumaAsegurada: 0},
    ]);
    const numerosCoberturasAdicionales = ["26", "36", "37", "48", "49"];
    const iconsDict = {
        "26": <IconCamera className={classes.coverageIcon}/>,
        "36": <IconDeviceLaptop className={classes.coverageIcon}/>,
        "37": <IconDeviceTablet className={classes.coverageIcon}/>,
        "48": <IconBike className={classes.coverageIcon}/>,
        "49": <IconScooter className={classes.coverageIcon}/>,
    }

    const handleOpenAlert = (message) => {
        setOpenAlert(true);
        setAlertMessage(message);
    };

    const handleCloseAlert = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        setOpenAlert(false);
        setAlertMessage(null);
    };

    function handleChecked(index) {
        let items = [...coberturasAdicionalesDict];
        let item = {...items[index]};
        item.selectedCoberturaAdicional = !item.selectedCoberturaAdicional;
        items[index] = item;

        values.coberturasAdicionales[index].selectedCoberturaAdicional = !values.coberturasAdicionales[index].selectedCoberturaAdicional
        setCoberturasAdicionalesDict(items);
    }

    function handleValueChange(e, index) {
        let value = e.target.value;
        if (!value.match(/^([0-9]{1,3}.([0-9]{3}.)*[0-9]{3}|[0-9]+)?$/))
            value = 0;
        else if (value === "")
            value = 0;
        else
            value = parseInt(value.toString().replace(/\./g, ""));
        let item = values.coberturas[index];

        if (value < dictCoberturas[item.numeroCobertura].sumaMinima) {
            handleOpenAlert(`El valor mínimo para esta cobertura es ${dictCoberturas[item.numeroCobertura].sumaMinima}`);
            value = dictCoberturas[item.numeroCobertura].sumaMinima
        }

        if (value > dictCoberturas[item.numeroCobertura].sumaMaxima) {
            handleOpenAlert(`El valor máximo para esta cobertura es ${dictCoberturas[item.numeroCobertura].sumaMaxima}`);
            value = dictCoberturas[item.numeroCobertura].sumaMaxima
        }

        setFieldValue(`coberturas[${index}].${sumaAsegurada.name}`, value)
    }

    function handleValueAditionalChange(e, index) {
        let value = e.target.value;
        if (!value.match(/^([0-9]{1,3}.([0-9]{3}.)*[0-9]{3}|[0-9]+)?$/))
            value = 0;
        else if (value === "")
            value = 0;
        else
            value = parseInt(value.toString().replace(/\./g, ""));

        let item = values.coberturasAdicionales[index];

        if (value < dictCoberturas[item.numeroCobertura].sumaMinima) {
            handleOpenAlert(`El valor mínimo para esta cobertura es ${dictCoberturas[item.numeroCobertura].sumaMinima}`);
            value = dictCoberturas[item.numeroCobertura].sumaMinima
        }

        if (value > dictCoberturas[item.numeroCobertura].sumaMaxima) {
            handleOpenAlert(`El valor máximo para esta cobertura es ${dictCoberturas[item.numeroCobertura].sumaMaxima}`);
            value = dictCoberturas[item.numeroCobertura].sumaMaxima
        }

        setFieldValue(`coberturasAdicionales[${index}].${sumaAseguradaAdicional.name}`, value)
    }

    useEffect(() => {
        let dict = {};
        coberturasInfo.map((item) =>
            dict[item.NumeroCobertura] = {
                sumaChica: item.SumaChica,
                sumaMediana: item.SumaMediana,
                sumaGrande: item.SumaGrande,
                sumaMaxima: item.SumaMaxima,
                sumaMinima: item.SumaMinima,
                descripcion: item.Descripcion,
                descripcionCompleta: item.DescripcionCompleta,
            });

        setDictCoberturas(dict)

        if (cotizacionRetomada) {
            setCoberturasAdicionalesDict(values.coberturasAdicionales)
        } else {
            for (let cobertura of values.coberturas) {
                if (values.tamanioVivienda === 'Chica')
                    cobertura.sumaAsegurada = dict[cobertura.numeroCobertura].sumaChica;
                else if (values.tamanioVivienda === 'Mediana')
                    cobertura.sumaAsegurada = dict[cobertura.numeroCobertura].sumaMediana;
                else if (values.tamanioVivienda === 'Grande')
                    cobertura.sumaAsegurada = dict[cobertura.numeroCobertura].sumaGrande;
            }
            for (let coberturaAdicional of values.coberturasAdicionales) {
                coberturaAdicional.sumaAsegurada = dict[coberturaAdicional.numeroCobertura].sumaChica;
                coberturaAdicional.selectedCoberturaAdicional = false;
            }
            setDictCoberturas(dict)
        }
    }, []);

    if (!dictCoberturas || !coberturasAdicionalesDict) return <Loading/>;
    return (
        <React.Fragment>
            <Grid container direction='column'>
                <Grid item container spacing={3} direction='column' className={classes.coberturasTable}>
                    <div style={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-between",
                        margin: "8px 72px 16px 16px",
                    }}>
                        <Typography className={classes.tableHeader}>Cobertura</Typography>
                        <Typography className={classes.tableHeader}>Suma Asegurada</Typography>
                    </div>
                    <FieldArray name='coberturas'>{() => (
                        values.coberturas.map((item, index) => (
                                <Fragment>
                                    <div style={{
                                        display: numerosCoberturasAdicionales.includes(item.numeroCobertura) ? "none" : "flex",
                                        flexDirection: "row",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                        minHeight: "48px",
                                        margin: "4px",
                                    }}>
                                        <div style={
                                            numerosCoberturasOpcionales.includes(item.numeroCobertura)
                                                ? {width: "60%"}
                                                : {width: "65%"}
                                        }>
                                            <Typography className={classes.tableRowLabel}>
                                                {dictCoberturas[item.numeroCobertura].descripcion}
                                            </Typography>
                                        </div>

                                        {numerosCoberturasOpcionales.includes(item.numeroCobertura) &&
                                        <div style={{width: "5%", margin: "0 -12px"}}>
                                            <Checkbox
                                                style={{color: "#bb0d66"}}
                                                checked={values.coberturas[index].selectedCobertura}
                                                onChange={() => {
                                                    setFieldValue(`coberturas[${index}].selectedCobertura`, !values.coberturas[index].selectedCobertura);
                                                }}
                                            />
                                        </div>
                                        }

                                        <p style={{width: "1%"}}>
                                            {item.selectedCobertura && (
                                                <span>$</span>
                                            )}
                                        </p>
                                        <div style={{width: "20%"}}>
                                            {item.selectedCobertura && (
                                                <NumberField
                                                    name={`coberturas[${index}].${sumaAsegurada.name}`}
                                                    label={""}
                                                    inputProps={{style: {textAlign: 'right'}}}
                                                    onBlur={(e) => handleValueChange(e, index)}
                                                />
                                            )}
                                        </div>
                                        <div style={{width: "5%"}}>
                                            <PopOverDetails
                                                descripcion={dictCoberturas[item.numeroCobertura].descripcionCompleta}/>
                                        </div>
                                    </div>
                                    <Divider light
                                             style={{display: numerosCoberturasAdicionales.includes(item.numeroCobertura) && "none"}}/>
                                </Fragment>
                            )
                        )
                    )}</FieldArray>


                    <Grid item container spacing={3} direction='column' className={classes.coberturasTable}>

                        <Typography className={classes.tableHeader} style={{margin: "32px 0px 16px 16px"}}>
                            Adicionales
                        </Typography>

                        {coberturasAdicionalesDict.map((item, index) => (
                            <div style={{
                                display: "flex",
                                flexDirection: "row",
                                alignItems: "center",
                                justifyContent: "space-between",
                                minHeight: "48px",
                                maxHeight: "48px",
                                margin: "4px",
                            }}>
                                <div style={{
                                    width: "65%", display: "flex",
                                    flexDirection: "row", alignItems: "center"
                                }}>
                                    <div style={{width: "10%"}}>
                                        <Checkbox
                                            style={{color: "#bb0d66"}}
                                            checked={coberturasAdicionalesDict[index].selectedCoberturaAdicional}
                                            value={coberturasAdicionalesDict[index]}
                                            onChange={() => handleChecked(index)}
                                        />
                                    </div>

                                    <div style={{
                                        width: "30%",
                                        display: "flex",
                                        flexDirection: "row",
                                        justifyContent: "center"
                                    }}>
                                        <Grid item xs={2} className={classes.centerContent}>
                                            {iconsDict[item.numeroCobertura]}
                                        </Grid>
                                    </div>

                                    <div style={{width: "60%"}}>

                                        <Typography className={classes.tableRowLabel}>
                                            {dictCoberturas[item.numeroCobertura].descripcion}
                                        </Typography>

                                    </div>

                                </div>


                                {item.selectedCoberturaAdicional ? <p style={{width: "1%",}}>$</p> :
                                    <p style={{width: "1%"}}>&nbsp;&nbsp;</p>
                                }

                                <div style={{width: "20%"}}>
                                    {item.selectedCoberturaAdicional && (
                                        <NumberField
                                            name={`coberturasAdicionales[${index}].${sumaAseguradaAdicional.name}`}
                                            label={""}
                                            inputProps={{style: {textAlign: 'right'}}}
                                            onBlur={(e) => handleValueAditionalChange(e, index)}
                                        />
                                    )}
                                </div>

                                <div style={{width: "5%"}}>
                                    <PopOverDetails
                                        descripcion={dictCoberturas[item.numeroCobertura].descripcionCompleta}
                                    />
                                </div>
                            </div>
                        ))}
                    </Grid>
                </Grid>
            </Grid>
            <Snackbar open={openAlert && alertMessage} autoHideDuration={5000} onClose={handleCloseAlert}>
                <Alert onClose={handleCloseAlert} severity="warning" elevation={6} variant="filled"
                       classes={{filledWarning: classes.alert}}
                >
                    {alertMessage}
                </Alert>
            </Snackbar>
        </React.Fragment>
    );
}
